export enum EmailStatus {
    VALID = 'valid',
    INVALID = 'invalid'
}
